const events = {};

export function subscribe(evt, callback) {
    if (!events[evt]) {
        events[evt] = {
            listeners: []
        };
    }

    if (typeof callback === 'function') {
        events[evt].listeners.push(callback);
    }
}

export function unsubscribe(evt, callback) {
    let foundIndex = -1;

    if (events[evt] && events[evt].listeners) {
        for (let i = 0; i < events[evt].listeners.length; i++) {
            if (events[evt].listeners[i] === callback) {
                foundIndex = i;
            }
        }

        if (foundIndex > -1) {
            events[evt].listeners.splice(foundIndex, 1);
        }
    }
}

export function publish(evt, payload) {
    if (events[evt] && events[evt].listeners) {
        for (let i = 0; i < events[evt].listeners.length; i++) {
            events[evt].listeners[i](payload);
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/eventBus.js